import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=425bac6a&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=js"
export * from "./AdminPage.vue?vue&type=script&lang=js"
import style0 from "./AdminPage.vue?vue&type=style&index=0&id=425bac6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425bac6a",
  null
  
)

export default component.exports